// removed by extract-text-webpack-plugin
module.exports = {"container":"lPaZGXaZVdO_bZtcHPNgp","input":"kmrqrDbmp-zvl_cwX3Kh2","input-wrapper":"MCB7ui30ggw2ZvwpGUoh7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/TextInputsSet.mod.css
// module id = 1704
// module chunks = 0